import { Platform } from 'react-native';

export type MobileStorePlatform = 'android' | 'ios';

/**
 * Phone/tablet OS from a browser user agent (ALL-22 smart landing).
 *
 * iPadOS 13+ Safari reports a desktop "Macintosh" UA; it is told apart from a
 * real Mac by its touch points. Anything else (desktop, bots, unknown) is
 * `null`, so the desktop web flow stays exactly as it was.
 */
export function detectMobileStorePlatform(
  userAgent: string | null | undefined,
  maxTouchPoints = 0,
): MobileStorePlatform | null {
  const ua = userAgent || '';
  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  if (/macintosh/i.test(ua) && maxTouchPoints > 1) return 'ios';
  return null;
}

/** The current browser's mobile store platform; always `null` outside web. */
export function currentMobileWebPlatform(): MobileStorePlatform | null {
  if (Platform.OS !== 'web' || typeof navigator === 'undefined') return null;
  return detectMobileStorePlatform(navigator.userAgent, navigator.maxTouchPoints || 0);
}
